<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Anexar documentos
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat>
        <v-card-text class="pt-0 pb-0">
          <anexar-documentos :items="getTiposDocsAnexar()" />
        </v-card-text>
        <v-card-actions class="pt-0">
          <finalizar-atestado />
          <botoes-stepper class="ml-2 mt-3" />
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AnexarDocumentos from "../../../../components/anexar-documentos/AnexarDocumentos.vue";
import BotoesStepper from "./BotoesStepper.vue";
import FinalizarAtestado from "./FinalizarAtestado.vue";
export default {
  components: {
    FinalizarAtestado,
    BotoesStepper,
    AnexarDocumentos,
  },
  computed: mapState("atestado",["step"]),
  data: () => ({
    stepConfig: 80,
  }),
  methods: {
    ...mapGetters("atestado", ["getTiposDocsAnexar"]),
  },
};
</script>

<style>
</style>